<div class="layout-column custom-panel full-width full-height">

  <div class="layout-column flex overflow-auto">
    <div class="layout-row layout-align-start-center padding-10">
      <app-bringoz-checkbox
        [isChecked]="selectedDayIds.length === visitDays.length"
        [isIndeterminate]="selectedDayIds.length && (selectedDayIds.length < visitDays.length)"
        (clickEvent)="onToggleSelectAll()">
      </app-bringoz-checkbox>
      <span class="br-body-2 font-weight-600 gray-101 margin-left-10" translate>All Days</span>
    </div>
    <hr class="main-divider">
    <div class="layout-column flex padding-10">
      <div *ngFor="let day of visitDays"
           class="layout-row layout-align-start-center margin-bottom-10">
        <app-bringoz-checkbox
          [isChecked]="isSelected(day.id)"
          [isDisabled]="dispatchedDaysMap[day.id]"
          (clickEvent)="onToggleSelect(day.id)">
        </app-bringoz-checkbox>
        <span class="br-body-2 font-weight-400 gray-101 margin-left-10"
              [class.gray-102]="dispatchedDaysMap[day.id]">
          {{ day | bringozDay: 'date': 'long' }} {{ day | bringozDate: 'date' }}
        </span>
      </div>
    </div>
  </div>

  <hr class="main-divider">

  <div class="layout-row layout-align-start-center padding-5">
    <bringoz-button [type]="'tertiary'"
                    [theme]="'primary'"
                    (onClick)="onCancel();$event.stopPropagation();">
      <span>{{ 'Cancel' | translate }}</span>
    </bringoz-button>
    <span class="flex"></span>


    <bringoz-button [theme]="'secondary'"
                    (onClick)="onSubmit();$event.stopPropagation();">
      <span>{{ 'Optimize Schedule' | translate }}</span>
    </bringoz-button>
  </div>

</div>
